<p *ngIf="!isJSON">  {{ description | truncateText : 250 }}</p> 
<p *ngIf="isJSON" [innerHTML]="jsonText | truncateText : 250"> </p>
 